import { Fetcher } from '@pp/core/src/api/Fetcher';

import type { RecentResultsType } from './types';

export interface FetchRecentResultsParams {
  JSESSIONID: string;
  tableId: string;
  numberOfGames: number;
  url: string;
  force?: boolean;
}

export const fetchRecentResults = ({
  JSESSIONID,
  tableId,
  numberOfGames,
  url,
  force = false,
}: FetchRecentResultsParams): Promise<RecentResultsType> => {
  return Fetcher.fetch<RecentResultsType>(url, {
    params: {
      JSESSIONID,
      tableId,
      numberOfGames,
    },
    force,
  });
};
